<template>
  <section class="col-12 col-xl-12 col-md-12 box-col-12">
    <div class="card item-summary">
      <div class="card-header d-flex">
            <div style="flex:1;">
              {{ $t('ringkasan_diri') }}
            </div>
            <div class="text-right" style="flex:1;">
              <a v-b-modal.summary class="text-right" >Edit</a>
            </div>

          </div>

      <div class="card-body">
        {{ summary }}
      </div>
    </div>

    <!-- Vertically centered Modal Component -->
    <b-modal
      id="summary"
      size="lg"
      width="100%"
      centered
      :title="$t('ringkasan_diri')"
      ok-title="Save"
      @ok="handleSubmit"
      cancel-title="Cancel"
      class="theme-modal"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-0">
            <h6 class="form-label">{{ $t('ringkasan_diri') }}</h6>
            <textarea
              class="form-control"
              rows="4"
              v-model="form.summary"
              :placeholder="$t('ringkasan_diri')"
            ></textarea>
          </div>
        </div>

      </div>
    </b-modal>
  </section>
</template>

<script>
  import { getDataRingkasanDiri,submitDataRingkasanDiri } from "../../_services/profile.service";
  export default {
    data() {
      return {
        summary:
          '-',
        form : {
          id_user : this.$route.query.id_user,
          id : null,
          summary : ''
        },
      };
    },
    mounted(){
      this.fetchDataSummary();
    },
    methods:{
      async fetchDataSummary(){
        let summary = await getDataRingkasanDiri(this.$route.query.id_user);
        if (summary) {
          this.summary = summary.about;
          this.form.id = summary.id;
          this.form.summary = summary.about;
        }else{
          this.summary = '-';
        }

      },
      async handleSubmit(){
        await submitDataRingkasanDiri(this.form);
        this.fetchDataSummary();
      }
    }
  };
</script>

<style lang="scss">
.item-summary {
  .card-header {
    padding: 18px 25px !important;
    font-size: 1.1rem;
    font-weight: 500;
  }
  .item {
    flex-direction: column;
    h3 {
      font-size: 0.8rem;
      font-weight: 500;
    }
    h5 {
      font-size: 0.8rem;
      font-weight: 400;
    }
  }
  .card-body {
    padding: 18px 25px !important;
  }

  .item-personal {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-address {
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-minat {
    -ms-flex: 0 0 30%;
    -webkit-box-flex: 0;
    flex: 0 0 30%;
    max-width: 30%;
    padding: 18px 25px;
    display: flex;
    flex-direction: column;

    .item-hobie {
      flex: 1;
      h3 {
        font-size: 0.8rem;
        font-weight: 500;
      }

      .list-item {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        .rounded {
          padding: 0.2rem 1rem;
          background: var(--theme-deafult);
          color: var(--theme-font);
          font-size: 0.6rem;
          border-radius: 1rem !important;
        }
      }
    }
  }

  .card-body {
    display: flex;
    .d-flex {
      width: 100%;
    }
  }
}
</style>
